/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Collapse,
  Well,
  Modal,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import Nvl from 'loracoms/Nvl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import PushInterface from './coms/PushInterface';
import PullInterfaces from './coms/PullInterfaces';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  planState: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  appState: React.PropTypes.object.isRequired,
};


class APIView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      appState: props.appState,
      planState: props.planState,
      showHelp: false,
      tokens: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.apiview');
  }

  componentWillReceiveProps(nextProps) {
    const { planState, appState } = nextProps;
    if (planState !== this.props.planState) {
      this.setState({ planState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }


  renderPushEditForm() {
    const { appId } = this.props;
    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('pushinterface.header')}>
        <PushInterface appId={appId} />
      </Panel>
    );
  }

  renderHelpWell() {
    const locale = this.props.intl.locale;
    return (
      <Well bsClass="aisz-well-light">
        <div>
          <p>
            <FormattedMessage id="applicationdetail.apiview.help.content1" />
          </p>
          <p>
            <FormattedMessage id="applicationdetail.apiview.help.content2" />
            <FormattedMessage id="applicationdetail.apiview.help.content3" />
            {' '}
            <Link onClick={() => window.open(`/static/docs/${locale}/Application.html`)}>
              <i className="fa fa-book" aria-hidden="true" />
              {' '}
              <FormattedMessage id="applicationdetail.apiview.help.content3.link" />
            </Link>
          </p>
        </div>
      </Well>
    );
  }

  renderToolbar() {
    const { pushState } = this.props;
    const { appState } = this.state;
    const { status, data: { name } = {} } = appState;

    const breadcrumb = [{
      onClick: () => pushState('/application'),
      content: <FormattedMessage id="application.breadcrumb.application" />,
    }, {
      content: (
        <span>
          <Nvl val={name} status={status} />
          {' '}
          <span style={{ marginLeft: '10px' }}>
            <Link onClick={() => this.setState({ showHelp: !this.state.showHelp })}>
              <span className="halflings halflings-question-sign" />{' '}
              { this.intlMsg.msg('showhelp.btn') }
            </Link>
          </span>
        </span>
      ),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderAddErrModal() {
    const { addErr } = this.state;
    let content = null;

    switch (addErr) {
      case 'QUOTA':
        content = (
          <div>
            {this.intlMsg.msg('apis.adderr.quota')}
            <br />
            <Link href="mailto:support@aisenz.com">support@aisenz.com</Link>
          </div>
        );
        break;
      default:
        content = this.intlMsg.msg('apis.adderr.general');
        break;
    }

    return (
      <Modal
        show={!_.isNil(this.state.addErr)}
        bsClass="aisz-modal-warning"
        onHide={() => this.setState({ addErr: null })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <span className="halflings halflings-warning-sign" />
            {' '}
            {this.intlMsg.msg('apis.adderr.modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {content}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderContent() {
    const { appId } = this.props;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            { this.renderToolbar() }
          </Col>
        </Row>
        <Collapse in={this.state.showHelp}>
          <Row>
            <Col md={12}>
              { this.renderHelpWell() }
            </Col>
          </Row>
        </Collapse>
        <Row>
          <Col md={12}>
            <PullInterfaces appId={appId} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            { this.renderPushEditForm() }
          </Col>
        </Row>
        <div>
          { this.renderAddErrModal() }
        </div>
      </Grid>
    );
  }

  render() {
    const { planState } = this.state;
    if (planState.status !== 'success') {
      return <PageLoading />;
    }
    if (planState.data.tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <div>
        {this.renderContent()}
      </div>
    );
  }
}


APIView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  planState: state.billing.plan,
  appId: ownProps.params.id,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(APIView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/index.jsx